import { fmtDate } from '../format';

/** Consommé d'un forfait (feuilles d'heures ou Jira) face aux jours vendus, au format des anneaux
    de la liste des projets ; `due` = jours vendus × part de la période écoulée (point de repère). */
export interface DaysUse {
  consumed: number | null;
  quota: number;
  unit: 'j';
  pct: number | null;
  alert: boolean;
  warn: boolean;
  due: number | null;
  loading: boolean;
}

const round1 = (n: number) => Math.round(n * 10) / 10;

// Rouge au-delà des jours vendus, orange au-delà de 80 % (comme les anciennes jauges).
export function fixedPriceUse(
  consumed: number | null,
  sold: number,
  share: number | null,
): DaysUse {
  const pct = consumed != null && sold > 0 ? Math.round((consumed / sold) * 100) : null;
  return {
    consumed,
    quota: sold,
    unit: 'j',
    pct,
    alert: pct != null && pct > 100,
    warn: pct != null && pct > 80 && pct <= 100,
    due: share != null && sold > 0 ? round1(share * sold) : null,
    loading: false,
  };
}

/* Infobulle d'un anneau de forfait : temps écoulé sur la période, part des jours vendus
   consommée, dépassement. */
export function fixedPriceTip(
  use: DaysUse,
  share: number | null,
  what: string,
  from: string | null | undefined,
  to: string | null | undefined,
): (string | false)[] {
  if (!(use.quota > 0)) return ['Pas de jours vendus : consommé seul'];
  return [
    share != null &&
      `${Math.round(share * 100)} % de la période écoulée (${fmtDate(from)} → ${fmtDate(to)})`,
    use.pct != null && `${use.pct} % des jours vendus ${what}`,
    use.alert &&
      use.consumed != null &&
      `${round1(use.consumed - use.quota)}j au-delà des jours vendus`,
  ];
}
